import {openDialog} from 'platform/components';

import {
  VehicleFinancingBalloonPayment,
  VehicleFinancingDownPayment,
  VehicleFinancingTerm,
} from '@dms/api/sales';

import {Nullish} from 'shared/web';

import {RateMatrixCellData} from '../../types/RateMatrixCellData';
import {getRateMatrixCellLabel} from '../../utils/getRateMatrixCellLabel';
import {RateMatrixCellForm} from '../RateMatrixCellForm';

interface OpenRateMatrixCellDialogOptions {
  term: VehicleFinancingTerm;
  downPayment: VehicleFinancingDownPayment;
  balloonBracket: VehicleFinancingBalloonPayment | Nullish;
  initialData: RateMatrixCellData | undefined;
  onSubmit: (data: RateMatrixCellData) => void;
  onRemove: (() => void) | undefined;
  testId: string;
}

export function openRateMatrixCellDialog(options: OpenRateMatrixCellDialogOptions) {
  openDialog(
    <RateMatrixCellForm
      initialData={options.initialData}
      onSubmit={options.onSubmit}
      onRemove={options.onRemove}
      data-testid={options.testId}
    />,
    {
      id: 'rate-matrix-cell-dialog',
      title: getRateMatrixCellLabel(options),
      size: 'small',
    }
  );
}
